import React from "react";

import { BaseProp } from "../../@types/base-types";
import { Dialog } from "../Dialog";
import { Modal } from "../Modal";
import { ConvertWastrViewProvider } from "./context/ConvertWastrViewProvider";
import { ConvertWastr } from "./ConvertWastr";

type ConvertTokensModalProps = {
  onCancel: VoidFunction;
  onSubmit: VoidFunction;
} & BaseProp;

export const ConvertWastrModal: React.FC<ConvertTokensModalProps> = ({ onCancel, onSubmit }) => {
  return (
    <Modal onModalOverlayClick={onCancel}>
      <Dialog title="Convert WASTR" onCancel={onCancel} cancelAriaLabel="Close Convert WASTR Dialog">
        <ConvertWastrViewProvider>
          <ConvertWastr onCancel={onCancel} onSubmit={onSubmit} />
        </ConvertWastrViewProvider>
      </Dialog>
    </Modal>
  );
};
